import { forwardRef, type InputHTMLAttributes } from 'react';
import { cn } from '@/utils/cn';

type Props = InputHTMLAttributes<HTMLInputElement>;

export const Input = forwardRef<HTMLInputElement, Props>(function Input({ className, ...rest }, ref) {
  return (
    <input
      ref={ref}
      {...rest}
      className={cn(
        'h-11 w-full rounded-xl border border-border bg-bg-elevated px-3 text-sm',
        'placeholder:text-fg-subtle focus:border-accent focus:outline-none focus:ring-2 focus:ring-accent/30',
        'disabled:opacity-50',
        className
      )}
    />
  );
});
